export const iconFontAwesomeLogisticsTruck = (
	<i className="fa-solid fa-truck"></i>
);
